import { getconfig } from '@/utils/getconfig';
import { createApp, defineAsyncComponent } from 'vue';
import pinia from '@/stores/index';
import App from '@/App.vue';
import router from '@/router';
import { directive } from '@/directive/index';
import { i18n } from '@/i18n/index';
import other from '@/utils/other';
import axios from 'axios';
import { execute } from '@/services/api';
import registerFunLib from './utils/index.js';
import { store } from '@/store/store';
import { useRoute } from 'vue-router';
import * as echarts from 'echarts'
import ElementPlus from 'element-plus';
import { ElNotification, ElMessageBox, ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
// 样式初始化
import 'normalize.css';
// 全局样式
import '@/assets/css/global.scss';
// import '@/assets/css/iconfont.css';
import '@/theme/index.scss';
import SvgIcon from '@/components/SvgIcon/svgicon.vue';
// 统一导入el-icon图标
import * as ElIconModules from '@element-plus/icons-vue';
import gridLayout from 'vue3-grid-layout-next' 
import 'vue3-grid-layout-next/dist/style.css'
import vuedraggable from 'vue3-draggable-next'; 
import SketchRule from 'vue3-sketch-ruler'
import 'vue3-sketch-ruler/lib/style.css' 
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import '@babylonjs/core/Loading/loadingScreen'
import '@babylonjs/loaders/glTF'
import '@babylonjs/loaders/OBJ'
import { Buffer } from 'buffer'
import process from 'process'

const config = getconfig('/zconfig.json');
const dyTable = defineAsyncComponent(() => import('@/components/DyTable/index.vue'));
const dyTablev = defineAsyncComponent(() => import('@/components/DyTablev/index.vue'));
const dyBlock = defineAsyncComponent(() => import('@/components/DyBlock/index.vue'));
const dyBlockf = defineAsyncComponent(() => import('@/components/DyBlockf/index.vue'));
const dyTreev = defineAsyncComponent(() => import('@/components/DyTreev/index.vue'));
const FileUpload = defineAsyncComponent(() => import('@/components/FileCtl/Upload.vue'));
const dyBtn = defineAsyncComponent(() => import('@/components/DyBtn/index.vue'));
const dyPrint = defineAsyncComponent(() => import('@/components/dyPrint/index.vue'));
const approval = defineAsyncComponent(() => import('@/components/Approval/approval.vue'));
const FileAttach = defineAsyncComponent(() => import('@/components/FileCtl/Attach.vue'));
const FileDownload = defineAsyncComponent(() => import('@/components/FileCtl/download'));
const FilePreview = defineAsyncComponent(() => import('@/components/FileCtl/Preview'));
const dyAf = defineAsyncComponent(() => import('@/components/DyAF/index.vue'));
const CustomSwitch = defineAsyncComponent(() => import('@/components/CustomSwitch/index.vue'));
const ExcelImp = defineAsyncComponent(() => import('@/components/FileCtl/ExcelImp.vue'));
const ribbonStatus = defineAsyncComponent(() => import('@/components/RibbonStatus/index.vue'));

const app = createApp(App);
 
registerFunLib(app, execute, echarts, axios, ElNotification, ElMessageBox, ElMessage, store, router);
directive(app);

app.component('SvgIcon', SvgIcon);
app.component('dyTable', dyTable);
app.component('dyTablev', dyTablev);
app.component('dyBlock', dyBlock);
app.component('dyBlockf', dyBlockf);
app.component('dyTreev', dyTreev);
app.component('dyBtn', dyBtn);
app.component('FileUpload', FileUpload);
app.component('approval', approval);
app.component('FileAttach', FileAttach);
app.component('FileDownload', FileDownload);
app.component('FilePreview', FilePreview);   
app.component('dyAf', dyAf);   
app.component('CustomSwitch', CustomSwitch);   
app.component('vuedraggable', vuedraggable);  
app.component('SketchRule', SketchRule)
app.component('ExcelImp', ExcelImp)
app.component('ribbonStatus', ribbonStatus)
//app.component('Drager', Drager)
// 统一注册el-icon图标
for (const [key, component] of Object.entries(ElIconModules)) {
  app.component(key, component as any);
}
 
app.use(pinia).use(router).use(ElementPlus).use(i18n).use(gridLayout).use(VXETable).mount('#app');
window['$vue'] = app;

